/** @format */

export const EnvelopeMedium = ({color}) => {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <path
                d="M20.5312 4.5C21.6182 4.5 22.5 5.33945 22.5 6.375C22.5 6.96484 22.2088 7.51953 21.7125 7.875L12.7875 14.25C12.3199 14.582 11.6801 14.582 11.2125 14.25L2.2875 7.875C1.79174 7.51953 1.5 6.96484 1.5 6.375C1.5 5.33945 2.38143 4.5 3.46875 4.5H20.5312ZM10.425 15.25C11.3602 15.918 12.6398 15.918 13.575 15.25L22.5 8.875V17C22.5 18.3789 21.3229 19.5 19.875 19.5H4.125C2.6751 19.5 1.5 18.3789 1.5 17V8.875L10.425 15.25Z"
                fill={color}
            />
        </svg>
    );
};
